import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {projectSessionKeys} from '../../../util/uiconstants';
import {loadStorage, saveStorage} from '../../Common/localStorage';

import {IconoirSidebarExpand, IconoirSidebarCollapse} from '@ey-xd/motif-icon';

import Globals from '../Globals';
import StyledTemplateWithSidebar from './StyledTemplateWithSidebar';
import Button from '../../CoreWrappers/Button';

const TemplateWithSidebar = ({children, includeScroll = true, renderSidebar = null}) => {
	const sessionKey = `${projectSessionKeys.sidebarCollapsed}`;

	const [collapsed, setCollapsed] = useState(true);

	useEffect(() => {
		const currentState = loadStorage(sessionKey);
		if (currentState === undefined) handleCollapseToggle(false);
		if (currentState === false) setCollapsed(false);
	}, []);

	const handleCollapseToggle = (value) => {
		saveStorage(sessionKey, value);
		setCollapsed(value);
	};

	const renderContent = () => {
		if (includeScroll) return <div className="customScrollbar">{children}</div>;
		return children;
	};

	const renderCollapseExpand = () => {
		const props = {
			svg: collapsed ? IconoirSidebarExpand : IconoirSidebarCollapse,
			onClick: () => handleCollapseToggle(!collapsed),
			size: 'large',
			variant: 'secondary',
			className: 'collapse-expand'
		};

		return <Button {...props} />;
	};

	return (
		<StyledTemplateWithSidebar className={classNames({collapsed})}>
			<Globals />
			{renderSidebar && renderCollapseExpand()}
			{renderSidebar && renderSidebar()}
			<section>{renderContent()}</section>
		</StyledTemplateWithSidebar>
	);
};

TemplateWithSidebar.propTypes = {
	includeScroll: PropTypes.bool,
	renderSidebar: PropTypes.func
};

export default TemplateWithSidebar;
